import React, { Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import _ from 'lodash';
import { ReactSortable } from 'react-sortablejs';
import classNames from 'classnames';
import Modal from '@material-ui/core/Modal';
import Drawer from '@material-ui/core/Drawer';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import TextField from '@material-ui/core/TextField';
import DeleteIcon from '@material-ui/icons/HighlightOff';
import EditTwoToneIcon from '@material-ui/icons/EditTwoTone';
import DoneTwoToneIcon from '@material-ui/icons/DoneTwoTone';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardMedia from '@material-ui/core/CardMedia';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Divider from '@material-ui/core/Divider';
import CloudOffIcon from '@material-ui/icons/CloudOff';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';

import Header from '../../components/Header';
import MenuDrawer from '../../components/MenuDrawer';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import { isAuthenticated, sendLogin } from '../../auth/Auth';
import { getAccounts } from '../../actions/Accounts';
import {
  getGiftCard,
  getCategories,
  editGiftCard,
  orderGiftCard,
  deleteGiftCard
} from '../../actions/GiftCard';
import GiftCardAdd from '../organisms/GiftCardAdd';
import GiftCardAddButton from '../../components/atoms/GiftCardAddButton';
import GiftCardOrderButton from '../../components/atoms/GiftCardOrderButton';
import ConfirmDeleteDialog from '../../components/molecules/ConfirmDialog';
import ExPagination from '../../components/molecules/ExPagination';

const styles = theme => ({
  root: {
    backgroundColor: '#e0e0e0',
    flexGrow: 1,
    paddingBottom: 20,
    width: '100%'
  },
  pageTitileDiv: {
    paddingLeft: 20,
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff'
  },
  pageDiscriptionDiv: {
    paddingLeft: 26,
    paddingTop: 2,
    textAlign: 'left'
  },
  mainPaper: {
    position: 'relative',
    margin: 20,
    padding: 20
  },
  zoom: {
    position: 'relative',
    left: -10,
    top: 20
  },
  mainPaperTitleDiv: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '20px 26px 10px 26px'
  },
  searchForm: {
    padding: '10px 26px 10px 26px'
  },
  buttonGroupLeft: {
    textAlign: 'left',
    float: 'left'
  },
  buttonRight: {
    textAlign: 'right'
  },
  buttonGroupRight: {
    textAlign: 'right'
  },
  textInput100: {
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  modal: {
    maxWidth: 1200,
    height: '100%',
    margin: 'auto',
    padding: '5% 12px 5%'
  },
  image: {
    width: 'calc(16% - 10px)',
    '&:hover .delete': {
      display: 'block !important'
    },
    margin: 5,
    position: 'relative',
    border: '1px solid #ccc',
    padding: 5,
    borderRadius: 4,
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      width: 'calc(50% - 10px)'
    },
    [theme.breakpoints.up('md')]: {
      width: 'calc(33.3333% - 10px)'
    },
    [theme.breakpoints.up('lg')]: {
      width: 'calc(20% - 10px)'
    },
    [theme.breakpoints.up('xl')]: {
      width: 'calc(16.6666% - 10px)'
    }
  },
  delete: {
    // display: 'none',
    position: 'absolute',
    top: 0,
    right: 0,
    color: 'red'
  },
  previewImageWrap: {
    display: 'flex',
    WebkitFlexWrap: 'wrap',
    flexWrap: 'wrap'
  },
  previewImagePlaceHolder: {
    backgroundColor: '#C8EBFB'
  },
  nameWrap: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  editName: {
    marginTop: 20
  },
  name: {
    paddingTop: 30,
    paddingBottom: 20,
    paddingRight: 20,
    wordBreak: 'break-all'
  },
  topActions: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  divider: {
    margin: '20px 0'
  },
  noData: {
    display: 'flex',
    justifyContent: 'center'
  },
  cardWrap: {
    height: 300,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account,
      listCategories: state.giftcard.categories,
      giftcard: state.giftcard.data.list,
      totalCount: state.giftcard.data.count
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getAccounts,
          getGiftCard,
          getCategories,
          editGiftCard,
          orderGiftCard,
          deleteGiftCard
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openAdd', 'updateOpenAdd', false),
  withState('openDrawer', 'updateOpenDrawer', false),
  withState('openProgress', 'updateOpenProgress', false),
  withState('loading', 'updateLoading', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('page', 'setPage', 1),
  withState('rowsPerPage', 'setRowsPerPage', 100),
  withState('imagesList', 'updateImagesList', []),
  withState('category', 'setCategory', -1),
  withState('openLightBox', 'setOpenLightBox', false),
  withState('startImage', 'setStartImage', 0),
  withState('openConfirmDelete', 'setOpenConfirmDelete', 0),
  withState('selectedImageId', 'setSelectedImageId', 0),
  withState('editCardId', 'setEditCardId', 0),
  withState('editCardName', 'setEditCardName', ''),
  withState('orderMin', 'setOrderMin', null),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleRedirect: props => path => {
      props.history.push(path);
    }
  }),
  lifecycle({
    componentDidMount() {
      isAuthenticated(this.props);
      this.props.updateOpenProgress(true);
      this.props.updateLoading(true);
      this.props.actions.getAccounts({ cognitoUserId: '' }).then(async data => {
        this.props.checkSession(data);
        this.props.actions.getCategories().then(categoriesData => {
          this.props.checkSession(categoriesData);
        });
        this.props.actions
          .getGiftCard({
            page: 1,
            limit: this.props.rowsPerPage
          })
          .then(giftcardData => {
            this.props.checkSession(giftcardData);
            this.props.updateOpenProgress(false);
            this.props.updateLoading(false);
          })
          .catch(() => {
            this.props.updateOpenProgress(false);
            this.props.updateLoading(false);
          });
      });
    }
  })
);

const Main = enhance(
  ({
    classes,
    account,
    listCategories,
    giftcard,
    actions,
    openDrawer,
    updateOpenDrawer,
    openAdd,
    updateOpenAdd,
    loading,
    updateLoading,
    openProgress,
    updateOpenProgress,
    resultMessage,
    setResultMessage,
    imagesList,
    updateImagesList,
    category,
    setCategory,
    openLightBox,
    setOpenLightBox,
    startImage,
    setStartImage,
    openConfirmDelete,
    setOpenConfirmDelete,
    selectedImageId,
    setSelectedImageId,
    rowsPerPage,
    page,
    setPage,
    editCardId,
    setEditCardId,
    editCardName,
    setEditCardName,
    orderMin,
    setOrderMin,
    setRowsPerPage,
    totalCount,
    checkSession
  }) => {
    React.useEffect(() => {
      if (giftcard && _.isArray(giftcard)) {
        updateImagesList(giftcard);
      }
    }, [giftcard]);
    // page
    const progressOkAction = () => {
      updateOpenProgress(false);
    };

    const cancelAction = () => {
      updateOpenAdd(false);
    };

    const addAction = () => {
      updateOpenAdd(true);
    };

    const orderAction = () => {
      const imagesListLen = imagesList.length;
      if (imagesListLen > 0) {
        updateOpenProgress(true);
        updateLoading(true);
        let minOrder = 1;
        if (orderMin) {
          minOrder = orderMin;
        } else {
          const minOrderVal = _.minBy(imagesList, 'viewOrder');
          minOrder = _.get(minOrderVal, 'viewOrder', 1);
          setOrderMin(minOrder);
        }
        const oderParams = _.reduce(
          imagesList,
          (res, card, index) => {
            res.push({
              giftCardId: card.giftCardId,
              viewOrder: minOrder + index
            });
            return res;
          },
          []
        );
        actions
          .orderGiftCard({ giftCards: oderParams })
          .then(dataCard => {
            console.log(dataCard);
            // updateOpenProgress(false);
            setResultMessage('画像の表示順変更に成功しました。');
            updateLoading(false);
          })
          .catch(() => {
            // updateOpenProgress(false);
            setResultMessage('画像の表示順変更に失敗しました。');
            updateLoading(false);
          });
      }
    };

    const deleteImage = id => {
      updateOpenProgress(true);
      updateLoading(true);
      actions
        .deleteGiftCard(id)
        .then(dataDelete => {
          checkSession(dataDelete);
          if (_.get(dataDelete, 'type') === 'DELETE_GIFTCARD_SUCCESS') {
            const params = {
              page,
              limit: rowsPerPage
            };
            if (category > -1) {
              params.giftCardCategoryId = category;
            }
            setResultMessage('画像の削除に成功しました。');
            actions.getGiftCard(params).then(giftcardData => {
              // updateOpenProgress(false);
              updateLoading(false);
              checkSession(giftcardData);
            });
          } else {
            updateLoading(false);
            setResultMessage('画像の削除の失敗しました。');
          }
        })
        .catch(() => {
          // updateOpenProgress(false);
          setResultMessage('画像の削除の失敗しました。');
          updateLoading(false);
        });
    };

    const setState = value => {
      console.log('setState', value);
      updateImagesList(value);
    };

    const reGetImagesList = () => {
      const params = {
        page,
        limit: rowsPerPage
      };
      if (category > -1) {
        params.giftCardCategoryId = category;
      }
      actions.getGiftCard(params).then(giftcardData => {
        checkSession(giftcardData);
      });
    };

    const handleChangePage = (event, pageData, limit) => {
      updateOpenProgress(true);
      updateLoading(true);
      setPage(pageData);
      const params = {
        page: pageData,
        limit
      };
      if (category > -1) {
        params.giftCardCategoryId = category;
      }
      actions
        .getGiftCard(params)
        .then(giftcardData => {
          checkSession(giftcardData);
          updateOpenProgress(false);
          updateLoading(false);
        })
        .catch(() => {
          updateOpenProgress(false);
          updateLoading(false);
        });
    };

    const enableEditName = card => {
      setEditCardId(card.giftCardId);
      setEditCardName(card.giftCardName);
    };

    const setImageName = value => {
      setEditCardName(value);
    };

    const saveImageName = () => {
      updateOpenProgress(true);
      updateLoading(true);
      actions
        .editGiftCard(editCardId, { giftCardName: editCardName })
        .then(dataEdit => {
          if (_.get(dataEdit, 'type') === 'EDIT_GIFTCARD_SUCCESS') {
            setEditCardId(0);
            setEditCardName('');
            const params = {
              page,
              limit: rowsPerPage
            };
            if (category > -1) {
              params.giftCardCategoryId = category;
            }
            actions.getGiftCard(params).then(giftcardData => {
              checkSession(giftcardData);
              updateOpenProgress(false);
              updateLoading(false);
            });
          } else {
            updateLoading(false);
            setResultMessage('失敗しました');
          }
        })
        .catch(() => {
          updateLoading(false);
          setResultMessage('失敗しました');
        });
    };

    const handleChangeCategory = event => {
      const categoryVal = event.target.value;
      setCategory(parseInt(categoryVal, 10));
      setPage(1);
      updateOpenProgress(true);
      updateLoading(true);
      const params = {
        page,
        limit: rowsPerPage
      };
      if (parseInt(categoryVal, 10) > -1) {
        params.giftCardCategoryId = parseInt(categoryVal, 10);
      }
      actions
        .getGiftCard(params)
        .then(dataCard => {
          checkSession(dataCard);
          if (dataCard.type === 'GET_GIFTCARD_SUCCESS') {
            const mOrder = _.minBy(
              _.get(dataCard, 'payload.list', []),
              'viewOrder'
            );
            setOrderMin(_.get(mOrder, 'viewOrder', 1));
          }
          updateOpenProgress(false);
          updateLoading(false);
        })
        .catch(() => {
          updateOpenProgress(false);
          updateLoading(false);
        });
    };

    const renderLightBox = () => {
      return (
        <Lightbox
          mainSrc={imagesList[startImage].image}
          nextSrc={imagesList[(startImage + 1) % imagesList.length].image}
          prevSrc={
            imagesList[(startImage + imagesList.length - 1) % imagesList.length]
              .image
          }
          onCloseRequest={() => setOpenLightBox(false)}
          onMovePrevRequest={() =>
            setStartImage(
              (startImage + imagesList.length - 1) % imagesList.length
            )
          }
          onMoveNextRequest={() =>
            setStartImage((startImage + 1) % imagesList.length)
          }
          imageTitle={imagesList[startImage].giftCardName}
        />
      );
    };

    const handleOpenLigthBox = index => {
      setOpenLightBox(true);
      setStartImage(index);
    };

    const deleteAction = () => {
      deleteImage(selectedImageId);
      setOpenConfirmDelete(false);
    };

    const selectImage = id => {
      setOpenConfirmDelete(true);
      setSelectedImageId(id);
    };

    const handleChangeRowsPerPage = (event, numberRows) => {
      setRowsPerPage(numberRows);
    };

    const renderListImages = () => {
      return (
        imagesList &&
        imagesList.length > 0 &&
        imagesList.map((previewImage, index) => (
          <div className={classes.image} key={previewImage.giftCardId}>
            <Card className={classes.cardWrap}>
              <CardActionArea>
                <CardMedia
                  component="img"
                  image={previewImage.image}
                  onClick={() => handleOpenLigthBox(index)}
                />
              </CardActionArea>
            </Card>
            <div className={classes.nameWrap}>
              {previewImage.giftCardId === editCardId ? (
                <Fragment>
                  <TextField
                    // required
                    fullWidth
                    label="画像名"
                    className={classes.textField}
                    margin="normal"
                    onChange={e => {
                      setImageName(e.target.value);
                    }}
                    value={editCardName}
                    onBlur={saveImageName}
                  />
                  <IconButton
                    color="inherit"
                    className={classes.editName}
                    onClick={saveImageName}
                  >
                    <DoneTwoToneIcon />
                  </IconButton>
                </Fragment>
              ) : (
                <Fragment>
                  <Typography className={classes.name}>
                    {previewImage.giftCardName ? previewImage.giftCardName : ''}
                  </Typography>
                  <IconButton
                    color="inherit"
                    className={classes.editName}
                    onClick={() => enableEditName(previewImage)}
                  >
                    <EditTwoToneIcon />
                  </IconButton>
                </Fragment>
              )}
            </div>
            <IconButton
              color="inherit"
              className={classNames('delete', classes.delete)}
              onClick={() => selectImage(previewImage.giftCardId)}
            >
              <DeleteIcon />
            </IconButton>
          </div>
        ))
      );
    };

    return (
      <div className={classes.root}>
        <Header
          onMenuClick={() => {
            updateOpenDrawer(true);
          }}
        />
        <Drawer
          open={openDrawer}
          anchor="left"
          onClose={() => {
            updateOpenDrawer(false);
          }}
        >
          <div tabIndex={0} role="button">
            <MenuDrawer account={account} />
          </div>
        </Drawer>
        <div className={classes.pageTitileDiv}>
          <Typography variant="h6" color="textSecondary">
            ギフトカードの設定
          </Typography>
        </div>
        <Paper className={classes.mainPaper} elevation={1}>
          <div className={classes.topActions}>
            <FormControl className={classes.formControl}>
              <Select
                value={category}
                onChange={handleChangeCategory}
                displayEmpty
                className={classes.selectEmpty}
                inputProps={{ 'aria-label': 'Without label' }}
              >
                <MenuItem value={-1}>
                  <em>カテゴリ選択</em>
                </MenuItem>
                {listCategories.map(cat => (
                  <MenuItem
                    key={cat.giftCardCategoryId}
                    value={cat.giftCardCategoryId}
                  >
                    {cat.giftCardCategoryName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <div>
              <GiftCardOrderButton
                onClickAction={orderAction}
                disabled={category === -1 || !imagesList.length}
              />
              <GiftCardAddButton onClickAction={addAction} />
            </div>
          </div>
          <Divider className={classes.divider} />
          {category === -1 ? (
            <div className={classes.previewImageWrap}>{renderListImages()}</div>
          ) : (
            <ReactSortable
              className={classes.previewImageWrap}
              list={imagesList}
              setList={setState}
              ghostClass={classes.previewImagePlaceHolder}
              animation={200}
            >
              {renderListImages()}
            </ReactSortable>
          )}
          {imagesList.length > 0 ? (
            <ExPagination
              rowsPerPage={rowsPerPage}
              handleChangePage={handleChangePage}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
              totalCount={totalCount}
              offset={(page - 1) * rowsPerPage}
              selectedPage={page}
            />
          ) : (
            <div className={classes.noData}>
              <CloudOffIcon fontSize="large" />
            </div>
          )}
        </Paper>
        {openLightBox ? renderLightBox() : null}
        <ConfirmDeleteDialog
          openConfirm={openConfirmDelete}
          updateOpenConfirm={setOpenConfirmDelete}
          okAction={deleteAction}
          message="「その画像を削除したいですか」"
        />
        <Modal open={openAdd} className={classes.modal}>
          <GiftCardAdd
            cancelAction={cancelAction}
            updateImagesList={reGetImagesList}
            listCategories={listCategories}
          />
        </Modal>
        <ProgressDialog
          openProgress={openProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
